import React from 'react';
import { ISwitchProps } from './types';
import * as S from './styles';
import Box from '../UI/Box';
import Text from '../UI/Text';

const Switch: React.FC<ISwitchProps> = ({
  name,
  value,
  title,
  checked,
  onChange,
}) => {
  const renderTitle = () => {
    if (title) {
      return (
        <Text fontSize={16} fontWeight={700}>
          {title}
        </Text>
      );
    }
  };
  return (
    <Box alignItems="center" gap={5}>
      <S.SwitchInput>
        <S.SwitchCheckbox
          name={name}
          value={value}
          checked={checked}
          type="checkbox"
          onChange={onChange}
        />
        <S.SwitchBody />
      </S.SwitchInput>

      {renderTitle()}
    </Box>
  );
};

export default Switch;
